export default () => ({
  restaurantesNegocio: [],
});
